var data = {
  "body": "<path d=\"M2.5 0L1 1.5L3.5 4L1 6.5L2.5 8l4-4l-4-4z\" fill=\"currentColor\"/>",
  "width": 8,
  "height": 8
};
export default data;